import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Homepage.css';
import Logo from '../assets/ChatGPT Image Jun 27, 2025, 04_00_20 PM.png';

const Homepage = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/connect-wallet');
  };

  return (
    <div className="homepage-section">
      <div className="homepage-container">
        <div className="homepage-content">
          <img src={Logo} alt="V Logo" className="homepage-logo" />
          <h1 className="brand-name">VORTREX</h1>
          <h2 className="token-symbol">TRADING BOT</h2>
          <h3 className="headline">🚀 Next-Gen AI Crypto Trading Bot</h3>
          <p className="subtext">
            <strong>Secure. Smart. Self-Driven.</strong><br />
            Unlock the power of AI to grow your crypto daily — auto-trading powered by intelligent algorithms.
          </p>

          {/* ✅ Get Started Button With Pulse */}
          <button className="get-started-btn pulse-button" onClick={handleGetStarted}>
            🚀 Start Free Trial
          </button>

          <div className="homepage-usp">
            <p>🤖 AI-Powered Trades</p>
            <p>🛡 Funds Stay in Your Wallet</p>
            <p>💸 25-30% Avg Daily ROI</p>
          </div>

          <div className="highlight-box-container">
            <div className="highlight-box presale">
              🎁 <strong>Try Free Mode First</strong> – Activate Trial to See Daily Profits Live
            </div>
            <div className="highlight-box utilities">
              🌱 <strong>Auto Reinvest Mode Launching Soon</strong> – Watch your wallet balance multiply without lifting a finger.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
